import { CaptureResult } from "posthog-js";

// rrweb's "meta" event, the one in a session replay that records the page url.
const REPLAY_META_EVENT = 4;

/**
 * PostHog `before_send` hook. The launcher's url carries the operator's session token (and the casino's
 * page, sent as the referrer, can carry its own), so query strings are dropped from every url PostHog
 * would store: event and person properties, and the page url inside session replays.
 */
export const stripUrlQueries = (event: CaptureResult | null): CaptureResult | null => {
  if (!event) return event;

  stripUrlValues(event.properties);
  stripUrlValues(event.$set);
  stripUrlValues(event.$set_once);

  const replayEvents = event.properties?.$snapshot_data;
  if (Array.isArray(replayEvents)) {
    for (const replayEvent of replayEvents) {
      if (replayEvent?.type === REPLAY_META_EVENT && typeof replayEvent.data?.href === 'string') {
        replayEvent.data.href = stripQuery(replayEvent.data.href);
      }
    }
  }

  return event;
};

const stripUrlValues = (properties: Record<string, any> | undefined) => {
  if (!properties) return;

  for (const key of Object.keys(properties)) {
    if (typeof properties[key] === 'string') {
      properties[key] = stripQuery(properties[key]);
    }
  }
};

const stripQuery = (value: string): string => {
  if (!/^https?:\/\/[^?#]*[?#]/i.test(value)) return value;

  try {
    const url = new URL(value);
    url.search = '';
    url.hash = '';
    return url.href;
  } catch {
    return value;
  }
};
